import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { TinyBusy } from "components/tiny/TinyLoading";

/**
 * 全域 loading 指示（Redux `data.fetch_status` 驅動，Admin layout 掛一次）。
 *
 * v2.42.0：原本是一個深色背景的置中 modal（「List R2H Revenue / Please wait...」），
 * 每次 Redux fetch 都整頁蓋住 —— Brad 指出「有些頁彈 modal、有些頁在內容區轉」不一致。
 * 全站統一後，這裡改成畫面頂端置中的浮動狀態列：同一套圈圈與文案風格、不擋操作。
 * 只有走 Redux action 的舊頁（Revenue.js 的 OA / R2H 區塊等）會用到；
 * Tiny 頁面各自用 <TinyLoading> / <TinyLoadingOverlay>。
 */
const LoadingModal = ({ fetchStatus }) => {
  const { status, action } = fetchStatus;
  const isLoading = status === 'loading';

  // action 名稱轉成可讀字串（camelCase → Title Case），特例保留
  const formatActionName = (a) => {
    if (!a) return "載入資料";
    if (a === "listR2HRevenue") return "List R2H Revenue";
    return a.replace(/([A-Z])/g, ' $1').replace(/^./, (s) => s.toUpperCase()).trim();
  };

  return (
    <div
      className={`tiny-loading-toast${isLoading ? "" : " tiny-loading-toast--hidden"}`}
      role="status"
      aria-live="polite"
      aria-hidden={!isLoading}
    >
      <TinyBusy light />
      <span>{formatActionName(action)}</span>
    </div>
  );
};

LoadingModal.propTypes = {
  fetchStatus: PropTypes.object.isRequired,
};

// Redux store 可能是 Immutable.js 也可能是 plain object，兩種都接
const mapStateToProps = (state) => {
  const defaultFetchStatus = { status: 'idle', action: null, error: null };
  try {
    if (!state) return { fetchStatus: defaultFetchStatus };
    let fetchStatus;
    if (state.getIn && typeof state.getIn === 'function') {
      const im = state.getIn(["data", "fetch_status"]);
      fetchStatus = im ? (typeof im.toJS === 'function' ? im.toJS() : im) : defaultFetchStatus;
    } else if (state.data && state.data.fetch_status) {
      fetchStatus = state.data.fetch_status;
    } else {
      fetchStatus = defaultFetchStatus;
    }
    return { fetchStatus };
  } catch (error) {
    console.error("Error mapping Redux state to props:", error);
    return { fetchStatus: defaultFetchStatus };
  }
};

export default connect(mapStateToProps)(LoadingModal);
